function main() {
  var urlPrefix = '';
  if (window.location.href.indexOf('teamsite') > -1) {
    urlPrefix = '/iw-mount/default/main/Toyota/BAT/WWW/WORKAREA/shared_wa/web_docs';
  }

  requirejs.config({
    /* The starting folder from where we read the files */
    baseUrl: urlPrefix + '/assets/src',
    /* The number of seconds to wait before giving up on loading a script. The default is 7 seconds. */
    waitSeconds: 5,
    /* Relative paths to files. Final path will be baseUrl+paths */
    paths: {
      txt: 'vendor/text',
      googlemaps: 'lib/shim/google.maps.loader',
      'vendor/gsap/lib': 'vendor/gsap/src/uncompressed/TweenMax',
      'vendor/gsap/plugins/ScrollToPlugin': 'vendor/gsap/src/uncompressed/plugins/ScrollToPlugin',
      TweenLite: 'vendor/gsap/src/uncompressed/TweenLite',
      jquery: 'vendor/jquery/jquery-3.2.1',
      tabControl: 'lib/util/tabControl',
      // facebook: 'vendor/facebook/sdk',
      jquerymigrate: 'vendor/jquery/jquery-migrate-3.0.0-production',
      jqueryui: 'vendor/jquery/jquery-ui-1.12.1.custom',
      jquerytouch: 'vendor/jquery/jquery.ui.touch-punch',
      lazyload: 'vendor/lazyLoad/jquery.lazy',
      modernizr: 'vendor/modernizr/modernizr',
      detectizr: 'vendor/detectizr/detectizr',
      Handlebars: 'vendor/handlebars/handlebars',
      responsive: 'lib/responsive',
      bxSlider: 'vendor/bxslider/bxslider-4.1.1-fixed',
      bxStrip: 'components/bxstrip',
      bxStripComponents: 'components/bxstrip-components',
      textfit: 'vendor/jquery/jquery.textFit.min',
      bootstrapCollapse: 'vendor/bootstrap/collapse',
      bootstrapTooltip: 'vendor/bootstrap/tooltip',
      bootstrapModal: 'vendor/bootstrap/modal',
      bootstrapTab: 'vendor/bootstrap/tab',
      bootstrapTransition: 'vendor/bootstrap/transition',
      isotopeVendor: 'vendor/isotope/isotope-1.5.26-fixed',
      global: 'components/global',
      Maps: 'lib/maps',
      componentDealerDetail: 'components/dealer-detail',
      // DealerPanel: 'components/dealer-panel',
      // DealerPanelComponents: 'components/dealer-panel-components',
      componentAllOffers: 'components/all-offers',
      // componentOffersCarousel: 'components/header-carousel-offers',
      componentSitemap: 'components/national-sitemap',
      h5validate: 'vendor/h5Validate/jquery.h5validate',
      dropkick: 'vendor/dropkick/dropkick',
      componentIsotope: 'components/isotope',
      inpageHeadline: 'components/inpage-headline',
      bat: 'components/bat',
      // footer: 'components/footer',
      tdaUtils: 'utils/tda-util',
      storageUtil: 'utils/storage-util',
      disclaimers: 'components/disclaimers',
      ajaxComponent: 'components/ajax-component',
      ajaxOffers: 'components/ajax-offers',
      zipTools: 'components/zip-tools',
      cookies: 'utils/cookies',
      ctaUtil: 'utils/cta-util',
      dealerLiveChat: 'utils/dealer-live-chat',
      webStorage: 'utils/webstorage',
      dealerSeo: 'components/dealer-seo',
      isInViewport: 'vendor/isinviewport/isInViewport',
      firstMoverParticipant: 'components/first-mover-participant',
      postMessage: 'vendor/jquery/jquery.postmessage.min',
      gxp: 'components/gxp',
      paymentEstimatorIframe: 'components/payment-estimator-iframe',
      odometer: 'vendor/odometer/odometer'
    },
    shim: {
      modernizr: {
        exports: 'Modernizr'
      },
      // facebook: {
      //   exports: 'FB'
      // },
      jqueryui: {
        deps: ['jquery']
      },
      jquerytouch: {
        deps: ['jquery', 'jqueryui']
      },
      lazyload: {
        deps: ['jquery']
      },
      jquerymigrate: {
        deps: ['jquery']
      },
      bxSlider: {
        deps: ['jquery']
      },
      textfit: {
        deps: ['jquery']
      },
      h5valide: {
        deps: ['jquery']
      },
      bootstrapCollapse: {
        deps: ['jquery']
      },
      bootstrapTab: {
        deps: ['jquery']
      },
      bootstrapTooltip: {
        deps: ['jquery']
      },
      bootstrapModal: {
        deps: ['jquery']
      },
      bootstrapTransition: {
        deps: ['jquery']
      },
      isotopeVendor: {
        deps: ['jquery']
      },
      Handlebars: {
        deps: ['jquery'],
        exports: 'Handlebars'
      },
      dropkick: {
        deps: ['jquery']
      },
      detectizr: {
        deps: ['modernizr'],
        exports: 'Detectizr'
      },
      isInViewport: {
        deps: ['jquery']
      },
      postMessage: {
        deps: ['jquery']
      }
    }
  });

  // We need to begin updating our dataLayer immediately,
  // so create it here if data-layer.js didn't already do so
  window.bat = window.bat || {};
  window.dataLayerBAT = window.dataLayerBAT || {};
  window.dataLayerBAT.data = window.dataLayerBAT.data || {};
  window.bat.IS_LOADED = false;

  /*
    If your javascript file is not included as a dependency in one of the JS files
    already listed here (maybe it's only listed as a dependency from within XSL) it will need to be listed here.
  */
  requirejs([
    'jquery',
    'tabControl',
    'storageUtil',
    // 'facebook',
    'jquerymigrate',
    'jqueryui',
    'jquerytouch',
    'lazyload',
    'modernizr',
    'detectizr',
    'Handlebars',
    'responsive',
    'bxSlider',
    'bxStrip',
    'bxStripComponents',
    'textfit',
    'bootstrapCollapse',
    'bootstrapTooltip',
    'bootstrapModal',
    'bootstrapTab',
    'bootstrapTransition',
    'isotopeVendor',
    'global',
    'componentDealerDetail',
    // 'DealerPanel',
    // 'DealerPanelComponents',
    'componentAllOffers',
    // 'componentOffersCarousel',
    'componentSitemap',
    'h5validate',
    'dropkick',
    'componentIsotope',
    'inpageHeadline',
    'bat',
    // 'footer',
    'tdaUtils',
    'disclaimers',
    'ajaxComponent',
    'ajaxOffers',
    'zipTools',
    'cookies',
    'dealerLiveChat',
    'ctaUtil',
    'webStorage',
    'features/vehicle-info/vehicle-info',
    'features/vehicle-info/vehicle-benefits-calculator',
    'dealerSeo',
    'isInViewport',
    'Maps',
    'firstMoverParticipant',
    'postMessage',
    'paymentEstimatorIframe',
    'gxp',
    'odometer',
    'modules/module-canvas',
    'modules/module-bundle.std',
    'components/nav/navigation',
    'components/nav/navigation-bundle.std',
    'features/inventory/inventory-landing',
    'features/inventory/inventory-vehicle',
    'features/inventory/inventory-detail',
    'features/compare/compare-association',
    'features/compare/compare-landing',
    'features/compare/compare-table',
    'features/goodbye-scion',
    'features/all-vehicles',
    'features/smartpath',
    'features/mirai-fuel-stations',
    'features/mirai-locator/mini-locator',
    'features/tools-page',
    'features/about-tda',
    'features/error-404',
    'features/slp/page',
    'features/pcu/page',
    'features/tss/tss',
    'features/iframe',
    'lib/tda/www',
    'components/offers/offer-detail-ajax',
    'components/offers/offers-strip',
    'features/vehicle-info/vehicle-info-build',
    'features/slp/form',
    'features/slp/thank-you',
    'lib/tda/saatchi',
    'components/footer',
    'components/dealer-panel-components',
    'components/header-carousel-offers'
  ], function ($, tabControl, storageUtil) {
    $(document).ready(function () {
      tabControl.init();
      window.bat.IS_LOADED = true;
      $(window).trigger('loaded');
      storageUtil.init();
    });
  });
}

(function (scope, main) {
  function loadScript(src, done) {
    var el = document.createElement('script');
    el.src = src;
    el.async = false;
    el.onload = function () {
      done && done();
    }
    el.onerror = function () {
      done && done(new Error('Failed to load script ' + src))
    }
    document.head.appendChild(el);
  }

  function needsPolyfill() {
    return !(scope.Promise && scope.Symbol);
  }

  if (needsPolyfill()) {
    loadScript('/assets/src/core-shim.min.js', main);
  } else {
    main();
  }
})(window, main);

define("require-config", function(){});

